import React from 'react';
import { Routes, Route, useRoutes } from 'react-router-dom';
import RedirectPage from './RedirectPage';

const App = () => {
  let routes = useRoutes([
    {
      path: '/',
      element: <RedirectPage />,
    },

  ]);

  return routes; // Sử dụng useRoutes để render các route
};

export default App;
